// extracted by mini-css-extract-plugin
export default {"wrapper":"hB-z","viewport":"iB-z","container":"jB-z","slide":"kB-z"};